/*
ashraf 10/10/2022 2700520533_2698849438  fixed role based access , client maintenance edit rate popup issues
 Suresh Peddavoora 10/30/2022 2700520533_2698849438  Added Class Name for Button Enhancements
Raghu 11/14/2022 2700520533_2698849438 Responsive Alignment Fixes
Ashraf 11/15/2022 2698849438 fixed page break issue
Dilip 12/22/2022 2698849438 changed button label clear to reset
*/
import React, {useEffect, useContext} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useForm} from 'react-hook-form';
import {Controller} from 'react-hook-form';
import {FormControl, Button} from '@material-ui/core';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import {fetchStateDropdown} from '../../../redux/reducers/AdvanceSearch';
import {
  fetchClientService,
  fetchClientParent,
  fetchServices,
  fetchClientPrefix,
  fetchSearchClientName,
} from '../../../redux/reducers/client-maintainance/ClientGeneral';
import {fetchClientData} from '../../../redux/reducers/ClientDashboard';
import {useHistory} from 'react-router';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {ThemeContext} from '../../../themes/ThemeProvider';

const SearchForm = ({setSearchedData, setAdvancedSearchData, setSubmit, clear, setClear}) => {
  const {clientParentData, clientPrefixData, clientData} = useSelector(
    ({clientGeneral}) => clientGeneral,
  );
  // const [companyTypeVal, setCompanyTypeVal] = useState('');
  const companyTypeVal = '';
  const {roleData} = useSelector(({role}) => role);
  const history = useHistory();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const getCommonOptions = (data) => {
    if (data?.length > 0) {
      return data;
    } else {
      return [];
    }
  };

  useEffect(() => {
    dispatch(fetchServices(companyTypeVal));
  }, [companyTypeVal]);

  useEffect(() => {
    dispatch(fetchStateDropdown());
    dispatch(fetchClientParent());
    dispatch(fetchClientService());
    dispatch(fetchClientPrefix());
    dispatch(fetchSearchClientName());
  }, [dispatch]);
  const {setSearchAnySubmit, setAdvanceSearchSubmit} = useContext(SelectTabContextProvider);

  const initialValues = {
    parentClientId: '',
    clientName: '',
    clientPrefix: '',
  };

  useEffect(() => {
    if (roleData &&
       Object.keys(roleData) &&
       roleData?.window &&
       !roleData?.window?.['Client Maintenance']?.CG?.read) {
      history.replace('/account-summary');
    }
  }, [roleData]);

  const onSubmit = (data) => {
    setSearchAnySubmit(false);
    setAdvanceSearchSubmit(true);
    setSubmit(true);
    setSearchedData('');
    setAdvancedSearchData(data ? data : '');
    const passValues = {
      parentClientName: data?.parentClientId?.parentClientName ?
        data?.parentClientId?.parentClientName :
        '',
      clientName: data?.clientName?.clientName ? data?.clientName?.clientName : '',
      searchBy: '',
      searchTerm: '',
      clientPrefix: data?.clientPrefix?.clientNumber ? data?.clientPrefix?.clientNumber : '',
    };
    dispatch(fetchClientData(passValues));
  };
  const {handleSubmit, control, setValue} = useForm({
    defaultValues: initialValues,
    mode: 'onChange',
  });
  return (
    <div className={`mb-0`}>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div>
          <div className="form-row align-items-center global-field-textfields">
            <div className="col-md-3 col-lg-2 col-sm-6 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}// Spread the properties from props to GuiTextField intentionally.
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="clientPrefix"
                      options={getCommonOptions(clientPrefixData)}
                      size="small"
                      autoHighlight
                      getOptionLabel={(option) => {
                        return option && option.clientNumber ? option.clientNumber : '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          {...params} // Spread the properties from params to GuiTextField intentionally.
                          variant="standard"
                          fullWidth
                          label="Client Prefix"
                          name="clientPrefix"
                          placeholder="Select Client Prefix"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="clientPrefix"
                  control={control}
                />
              </FormControl>
            </div>

            <div className="col-md-3 col-lg-4 col-sm-6 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="parentClientId"
                      options={getCommonOptions(clientParentData)}
                      size="small"
                      autoHighlight
                      getOptionLabel={(option) => {
                        return option && option.parentClientName ? option.parentClientName : '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          // className={`${classes.labelName} ${classes.selectLabel}`}
                          {...params}
                          variant="standard"
                          fullWidth
                          label="Parent Client"
                          name="parentClientId"
                          placeholder="Select Parent Client"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="parentClientId"
                  control={control}
                />
              </FormControl>
            </div>
            <div className="col-md-3 col-lg-4  col-sm-6 form-group">

              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="clientName"
                      options={getCommonOptions(clientData)}
                      size="small"
                      autoHighlight
                      getOptionLabel={(option) => {
                        return option && option?.clientName ? option?.clientName : '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          // className={`${classes.labelName} ${classes.selectLabel}`}
                          {...params}
                          variant="standard"
                          fullWidth
                          label="Client Name"
                          name="clientName"
                          placeholder="Select Client Name"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="clientName"
                  control={control}
                />
              </FormControl>
            </div>
            <div className="col-md-3 col-lg-2  col-sm-6 form-group">
              <div className="d-flex align-items-center">
                <Button
                  variant="outlined"
                  type="reset"
                  onClick={() => {
                    const data = {
                      clientName: '',
                      clientPrefix: '',
                      parentClientName: '',
                      searchBy: '',
                      searchTerm: '',
                    };
                    dispatch(fetchClientData(data));
                    setValue('clientName', '');
                    setValue('parentClientId', '');
                    setValue('clientPrefix', '');
                  }}
                  className={`reset-btn mx-1 ${classes.buttonRoot}`}
                >
             Reset
                </Button>
                <Button
                  type="submit"
                  variant="outlined"
                  className={`mx-1 search-btn ${classes.buttonRoot}`}
                >
              Search
                </Button>
              </div>
            </div>
          </div>

        </div>
      </form>
    </div>
  );
};

export default SearchForm;
